<ns-grid [name]="configs.gridName" [gridTitle]="configs.gridTitle" [columns]="configs.columns" [data]="submittedDiversions"
         [config]="configs.headerOptions" [gridOptions]="configs.options" [loading]="loading"
         [rowSelection]="configs.rowSelection">
</ns-grid>
